export const setProfile = (data) => {
  return (dispatch) => dispatch({ type: 'SET_PROFILE', data: data });
};

export const setCustomerProfile = (data) => {
  return (dispatch) => dispatch({ type: 'SET_CUSTOMER_PROFILE', data: data });
};
